.backdrop {
  position: fixed; inset: 0; z-index: 100;
  background: rgba(15, 18, 28, 0.45);
  display: flex; align-items: center; justify-content: center;
  padding: 40px 20px;
}
.card {
  background: #fff; border-radius: 10px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.24);
  width: 992px; max-width: 100%; max-height: 100%;
  display: flex; flex-direction: column; overflow: hidden;
}
.head {
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  padding: 16px 20px; flex-shrink: 0;
}
.headChips { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.chip {
  display: inline-flex; align-items: center; gap: 8px; padding: 8px;
  background: var(--bg-chip); box-shadow: inset 0 0 0 1px var(--border-chip);
  border-radius: var(--radius-chip);
  font-size: 12px; font-weight: 500; line-height: 16px; color: #000; white-space: nowrap;
}
.chipIcon { width: 16px; height: 16px; flex-shrink: 0; }
.close { width: 28px; height: 28px; border-radius: 6px; color: var(--text-value); font-size: 18px; line-height: 1; }
.close:hover { background: var(--bg-pill); }

.tabs { display: flex; gap: 8px; padding: 0 20px 12px; flex-shrink: 0; }
.tab {
  padding: 5px 14px; border-radius: var(--radius-pill);
  font-size: 13px; font-weight: 500; color: var(--text-value);
}
.tab:hover { background: var(--bg-pill); }
.tab.active { background: #2f6feb; color: #fff; }

.body { overflow: auto; padding: 0 20px 20px; }

.table { width: 100%; border-collapse: separate; border-spacing: 0; }
.table th {
  position: sticky; top: 0; z-index: 1;
  background: var(--bg-table-header);
  border-top: 1px solid var(--border-cell);
  border-bottom: 1px solid var(--border-cell);
  border-right: 1px solid var(--border-cell);
  padding: 14px 12px;
  font-size: 12px; font-weight: 600; line-height: 16px; color: var(--text-header);
  text-align: right; white-space: nowrap;
}
.table th:first-child { border-left: 1px solid var(--border-cell); text-align: left; }
.table td {
  border-bottom: 1px solid var(--border-cell);
  border-right: 1px solid var(--border-cell);
  padding: 14px 12px;
  font-size: 12px; line-height: 16px; color: var(--text-value);
  text-align: right; white-space: nowrap;
}
.table td:first-child { border-left: 1px solid var(--border-cell); text-align: left; }
.table tbody tr:hover td { background: #fafbfd; }
.center { text-align: center !important; }

.state { padding: 40px 12px; text-align: center; font-size: 13px; color: var(--text-muted); }
.count { font-size: 11px; color: var(--text-muted); padding: 10px 2px 0; }
